var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTableImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236.432,
    height: 181.533,
    viewBox: "0 0 236.432 181.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.227,
    x2: 0.5,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 86.402,
    y1: 0.412,
    x2: 87.007,
    y2: 0.823,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e9cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#176ad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.154,
    y1: 0.568,
    x2: 0.42,
    y2: 0.49,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bfad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2dad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.202,
    y1: 0.241,
    x2: 1.023,
    y2: 0.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.51,
    y1: 0.622,
    x2: 0.569,
    y2: 1.822,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bfad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#f2dad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.404,
    y1: 0.306,
    x2: 0.835,
    y2: 1.076,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.386,
    y1: 0.075,
    x2: 0.681,
    y2: 1.17,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6dbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb9a99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.314,
    y1: 0.412,
    x2: 0.919,
    y2: 0.823,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66454",
    "data-name": "Group 66454",
    transform: "translate(-823 -701.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66451",
    "data-name": "Group 66451",
    transform: "translate(823 798.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66449",
    "data-name": "Group 66449",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1038",
    "data-name": "Ellipse 1038",
    cx: 118.216,
    cy: 41.851,
    rx: 118.216,
    ry: 41.851,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66452",
    "data-name": "Group 66452",
    transform: "translate(872.808 742.544)",
    opacity: 0.487
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66382",
    "data-name": "Group 66382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66375",
    "data-name": "Group 66375",
    transform: "translate(12.469 1.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66372",
    "data-name": "Group 66372",
    transform: "translate(4.771 1.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67082",
    "data-name": "Path 67082",
    d: "M617.982,780.809a13.456,13.456,0,0,1,1.9-3.115c1.222-1.467,3.045-3.911,3.045-3.911s-.889,1.739-2.1,3.7A15.02,15.02,0,0,1,617.982,780.809Z",
    transform: "translate(-615.34 -770.667)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67083",
    "data-name": "Path 67083",
    d: "M620.87,773.941a7.786,7.786,0,0,0,2.166-3.314c.813-2.251,1.554-3.964,1.554-3.964a31.787,31.787,0,0,0-2.51,4.252C621.325,772.655,620.87,773.941,620.87,773.941Z",
    transform: "translate(-616.964 -766.663)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67084",
    "data-name": "Path 67084",
    d: "M617.835,778.862a28.364,28.364,0,0,0,.847-4.629c.139-2.055.123-3.346.123-3.346s-.893,3.729-1.162,5.312A5.127,5.127,0,0,0,617.835,778.862Z",
    transform: "translate(-615.103 -769.038)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67085",
    "data-name": "Path 67085",
    d: "M614.949,781.577a14.975,14.975,0,0,0-.519-5.023,15.783,15.783,0,0,1-.786-3.878,16.013,16.013,0,0,0,.067,4.624A30.663,30.663,0,0,0,614.949,781.577Z",
    transform: "translate(-612.822 -770.044)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67086",
    "data-name": "Path 67086",
    d: "M617.307,787.22a16.155,16.155,0,0,1,2.836-1.987,11.305,11.305,0,0,0,2.277-1.481,11.961,11.961,0,0,1-2.549,2.51C618.957,786.677,617.307,787.22,617.307,787.22Z",
    transform: "translate(-614.961 -776.273)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67087",
    "data-name": "Path 67087",
    d: "M613.643,788.381a7.6,7.6,0,0,0-.66-3.5,18.391,18.391,0,0,1-1.036-3.066,11.573,11.573,0,0,0,.5,3.831C613,786.692,613.643,788.381,613.643,788.381Z",
    transform: "translate(-611.946 -775.184)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67088",
    "data-name": "Path 67088",
    d: "M616.224,792.921a6.084,6.084,0,0,1,2.126-.869,5.119,5.119,0,0,0,1.322-.288,2.473,2.473,0,0,1-1.815,1.127A4.222,4.222,0,0,1,616.224,792.921Z",
    transform: "translate(-614.352 -780.778)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67089",
    "data-name": "Path 67089",
    d: "M614.607,789.686c.234-.91.535-2.318.846-3.258a28.771,28.771,0,0,1,2.315-4.75,32.8,32.8,0,0,0-2.223,5.353c-.2.755-.541,1.8-.727,2.487C614.788,789.705,614.638,789.862,614.607,789.686Z",
    transform: "translate(-613.442 -775.106)",
    fill: "#50cc85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66373",
    "data-name": "Group 66373",
    transform: "translate(2.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67090",
    "data-name": "Path 67090",
    d: "M612.447,780.262a14.3,14.3,0,0,0-.828-3.787c-.721-1.9-1.708-4.985-1.708-4.985s.292,2.056.825,4.448A15.97,15.97,0,0,0,612.447,780.262Z",
    transform: "translate(-608.526 -768.344)",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67091",
    "data-name": "Path 67091",
    d: "M613.5,772.9a8.283,8.283,0,0,1-1.031-4.08c-.038-2.544-.19-4.522-.19-4.522a33.787,33.787,0,0,1,1.052,5.142C613.484,771.452,613.5,772.9,613.5,772.9Z",
    transform: "translate(-609.856 -764.3)",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67092",
    "data-name": "Path 67092",
    d: "M615.748,780a30.124,30.124,0,0,1,.75-4.946c.571-2.114,1.033-3.405,1.033-3.405s-.393,4.056-.67,5.741A5.452,5.452,0,0,1,615.748,780Z",
    transform: "translate(-611.808 -768.431)",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67093",
    "data-name": "Path 67093",
    d: "M615.788,784.217a15.917,15.917,0,0,1,2.259-4.87,16.767,16.767,0,0,0,2.131-3.626,17.014,17.014,0,0,1-1.667,4.624A32.535,32.535,0,0,1,615.788,784.217Z",
    transform: "translate(-611.831 -770.722)",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67094",
    "data-name": "Path 67094",
    d: "M610.685,786.862a17.193,17.193,0,0,0-2.163-2.978,12,12,0,0,1-1.777-2.276,12.722,12.722,0,0,0,1.694,3.405C609.215,785.746,610.685,786.862,610.685,786.862Z",
    transform: "translate(-606.746 -774.033)",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67095",
    "data-name": "Path 67095",
    d: "M615.461,791.57a8.078,8.078,0,0,1,1.873-3.289,19.545,19.545,0,0,0,2.1-2.724s-.913,2.817-1.832,3.676S615.461,791.57,615.461,791.57Z",
    transform: "translate(-611.647 -776.253)",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67096",
    "data-name": "Path 67096",
    d: "M611.952,793.709a6.473,6.473,0,0,0-1.836-1.609,5.45,5.45,0,0,1-1.229-.747,2.628,2.628,0,0,0,1.434,1.76A4.488,4.488,0,0,0,611.952,793.709Z",
    transform: "translate(-607.95 -779.513)",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67097",
    "data-name": "Path 67097",
    d: "M615.069,791.143c.08-1,.264-2.514.277-3.567a30.594,30.594,0,0,0-.684-5.575,34.914,34.914,0,0,1,.383,6.15c-.062.827-.08,2-.13,2.75C614.88,791.1,614.977,791.311,615.069,791.143Z",
    transform: "translate(-611.197 -774.254)",
    fill: "#50cc85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66374",
    "data-name": "Group 66374",
    transform: "translate(0 2.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67098",
    "data-name": "Path 67098",
    d: "M606.085,783.4a13.442,13.442,0,0,0-1.9-3.115c-1.222-1.468-3.045-3.911-3.045-3.911s.889,1.739,2.1,3.7A15.022,15.022,0,0,0,606.085,783.4Z",
    transform: "translate(-601.102 -773.256)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67099",
    "data-name": "Path 67099",
    d: "M604.766,776.531a7.787,7.787,0,0,1-2.166-3.314c-.813-2.251-1.554-3.965-1.554-3.965a31.782,31.782,0,0,1,2.51,4.252C604.311,775.245,604.766,776.531,604.766,776.531Z",
    transform: "translate(-601.046 -769.252)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67100",
    "data-name": "Path 67100",
    d: "M610.977,781.452a28.351,28.351,0,0,1-.847-4.629c-.139-2.055-.123-3.346-.123-3.346s.893,3.729,1.162,5.312A5.128,5.128,0,0,1,610.977,781.452Z",
    transform: "translate(-606.084 -771.628)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67101",
    "data-name": "Path 67101",
    d: "M613.568,784.167a14.976,14.976,0,0,1,.519-5.024,15.776,15.776,0,0,0,.786-3.877,16.011,16.011,0,0,1-.067,4.624A30.669,30.669,0,0,1,613.568,784.167Z",
    transform: "translate(-608.069 -772.634)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67102",
    "data-name": "Path 67102",
    d: "M606.539,789.81a16.179,16.179,0,0,0-2.836-1.987,11.289,11.289,0,0,1-2.277-1.481,11.956,11.956,0,0,0,2.549,2.51C604.889,789.267,606.539,789.81,606.539,789.81Z",
    transform: "translate(-601.26 -778.862)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67103",
    "data-name": "Path 67103",
    d: "M614.571,790.971a7.606,7.606,0,0,1,.659-3.5,18.381,18.381,0,0,0,1.036-3.066,11.584,11.584,0,0,1-.5,3.831C615.209,789.282,614.571,790.971,614.571,790.971Z",
    transform: "translate(-608.642 -777.774)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67104",
    "data-name": "Path 67104",
    d: "M609.761,795.511a6.086,6.086,0,0,0-2.126-.869,5.112,5.112,0,0,1-1.322-.288,2.471,2.471,0,0,0,1.815,1.127A4.2,4.2,0,0,0,609.761,795.511Z",
    transform: "translate(-604.008 -783.368)",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67105",
    "data-name": "Path 67105",
    d: "M611.747,792.275c-.234-.91-.535-2.318-.846-3.258a28.754,28.754,0,0,0-2.315-4.75,32.774,32.774,0,0,1,2.223,5.353c.2.754.541,1.8.727,2.486C611.567,792.295,611.717,792.452,611.747,792.275Z",
    transform: "translate(-605.286 -777.696)",
    fill: "#50cc85"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67106",
    "data-name": "Path 67106",
    d: "M612.684,805.531h-5.106L606,796.537h8.446Z",
    transform: "translate(-603.832 -782.428)",
    fill: "#d2dceb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66377",
    "data-name": "Group 66377",
    transform: "translate(0 23.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66376",
    "data-name": "Group 66376",
    transform: "translate(8.457 3.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67107",
    "data-name": "Path 67107",
    d: "M754.567,822.719l8.421,52.654,1.621-.005-6.663-52.66Z",
    transform: "translate(-683.363 -822.708)",
    fill: "#a6aaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67108",
    "data-name": "Path 67108",
    d: "M605.031,822.788l-10.968,52.707-2.184.005,8.6-52.7Z",
    transform: "translate(-591.879 -822.753)",
    fill: "#a6aaab"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26761",
    "data-name": "Rectangle 26761",
    width: 90.609,
    height: 4.055,
    transform: "translate(4.344)",
    fill: "#a6aaab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26762",
    "data-name": "Rectangle 26762",
    width: 99.297,
    height: 2.692,
    fill: "#a6aaab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66379",
    "data-name": "Group 66379",
    transform: "translate(53.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66378",
    "data-name": "Group 66378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67109",
    "data-name": "Path 67109",
    d: "M726.932,783.567h-3.524l-3.524-22.486h2.679Z",
    transform: "translate(-708.641 -761.081)",
    fill: "#a6aeba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67110",
    "data-name": "Path 67110",
    d: "M711.476,783.567H697.721L694.2,761.081h13.755Z",
    transform: "translate(-694.196 -761.081)",
    fill: "#d2dceb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26763",
    "data-name": "Rectangle 26763",
    width: 14.952,
    height: 1.677,
    transform: "translate(3.339 21.976)",
    fill: "#d2dceb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26764",
    "data-name": "Rectangle 26764",
    width: 18.851,
    height: 1.677,
    transform: "translate(18.291 21.976)",
    fill: "#a6aeba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67111",
    "data-name": "Path 67111",
    d: "M712.723,786.378c.4,1.721.118,3.581-.626,4.153s-1.669-.36-2.068-2.081-.118-3.581.626-4.153S712.325,784.657,712.723,786.378Z",
    transform: "translate(-702.998 -774.041)",
    fill: "#a6aeba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66381",
    "data-name": "Group 66381",
    transform: "translate(37.221 17.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67112",
    "data-name": "Path 67112",
    d: "M661.945,806.717h-1.951a1.635,1.635,0,0,1-1.615-1.384l-.779-5.021h6.741l-.779,5.021A1.635,1.635,0,0,1,661.945,806.717Z",
    transform: "translate(-657.599 -800.313)",
    fill: "#a6aeba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66380",
    "data-name": "Group 66380",
    transform: "translate(4.587 0.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67113",
    "data-name": "Path 67113",
    d: "M669.646,806.534c-.071,0-.142,0-.216-.008l-.091-.007-.073-.056a3.117,3.117,0,0,1-1.187-2.2,2.188,2.188,0,0,1,1.934-2.37,2.019,2.019,0,0,1,1.57.667,2.049,2.049,0,0,1,.36,1.756h0A2.328,2.328,0,0,1,669.646,806.534Zm-.073-.614c1.231.039,1.619-.9,1.766-1.715h0a1.475,1.475,0,0,0-.227-1.253,1.41,1.41,0,0,0-1.1-.448c-.727,0-1.319.787-1.319,1.756A2.455,2.455,0,0,0,669.572,805.92Z",
    transform: "translate(-668.079 -801.89)",
    fill: "#a6aeba"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_67114",
    "data-name": "Path 67114",
    d: "M654.313,814.016h8.543l1.362-1.508H652.951Z",
    transform: "translate(-617.764 -789.999)",
    fill: "#d2dceb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66453",
    "data-name": "Group 66453",
    transform: "translate(953.45 701.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67128",
    "data-name": "Path 67128",
    d: "M1567.691,948.754s-.069,4.021,0,4.424-1.574,2.76-2.245,2.655a7.35,7.35,0,0,1-2.208-.552c-.194-.224-.108-.751-.039-1.233s.571-4.861.571-5.085S1566.945,948.142,1567.691,948.754Z",
    transform: "translate(-1528.649 -843.324)",
    fill: "#ffd3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67129",
    "data-name": "Path 67129",
    d: "M1563.8,964.219c-.84.454-1.311,1.835-1.43,1.852s-.341-.017-.341-.153.034-.6-.119-.6-.324.75-.358,1.842-.422,3.695,0,4.026c.265.208,2.7,1.484,2.764,1.655s-.051,1.365.153,1.552.682.648,1.057.666a16.311,16.311,0,0,0,3.565,0,7.853,7.853,0,0,0,2.354-.87,12.535,12.535,0,0,0-.58-3.395c-.324-.358-2.661-3.565-2.849-3.855a3.309,3.309,0,0,1-.324-1.4,1.8,1.8,0,0,0-1.06-1.518A4.82,4.82,0,0,0,1563.8,964.219Z",
    transform: "translate(-1527.358 -854.596)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67130",
    "data-name": "Path 67130",
    d: "M1488.7,957.412s0,2.342-.068,2.745,1.574,2.759,2.245,2.655a7.345,7.345,0,0,0,2.208-.552c.194-.224.109-.751.039-1.234s-.5-3.182-.5-3.406S1489.441,956.8,1488.7,957.412Z",
    transform: "translate(-1474.164 -849.656)",
    fill: "#ffd3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67131",
    "data-name": "Path 67131",
    d: "M1487.751,764.159A120.63,120.63,0,0,0,1485,785.2c0,5.751-.575,20.417-.575,22.646s-.24,7.758.336,8.046a5.757,5.757,0,0,0,3.744.864,2.464,2.464,0,0,0,2.352-2.5c.048-1.056.48-8.639.912-11.567s1.968-8.575,2.976-12.207,3.36-10.936,3.984-10.908,4.511,16.029,4.835,16.936.941,13.792.981,14.872,0,2.122.681,2.563a11.956,11.956,0,0,0,3.844,1.6c1.081.08,1.8-1.642,2-2.162s.555-17.754.427-22.482.246-13.543.027-16.418a82.441,82.441,0,0,0-1.369-10.331C1509.713,762.863,1487.751,764.159,1487.751,764.159Z",
    transform: "translate(-1471.057 -708.078)",
    fill: "#192b59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67132",
    "data-name": "Path 67132",
    d: "M1459.347,574.776c.906-1.008,5.139-5.777,5.978-5.945s2.884-.537,3.339-1.008,2.384-6.522,1.62-7.623-3.708-.788-4.6,1.085-.848,2.855-2.32,4.149-7.887,6.538-8.484,7.068.587,3.1,1.524,3.55S1459.347,574.776,1459.347,574.776Z",
    transform: "translate(-1449.364 -558.854)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67133",
    "data-name": "Path 67133",
    d: "M1456.454,610.086c-2.162.453-5.755.837-6.94,1.221s-5.859,2.023-5.824,1.325,2.162-3.767,1.779-4.081-2.685-.7-3.069-1.186-.907-1.639-1.43-1.5-6.588,5.789-6.173,7.952c.979,5.1,15.313,8.814,15.64,11.038s-1.112,23.547-.327,24.332,9.092,3.794,13.278,4.056,11.53-1.2,11.93-2.3-2.042-22.288-1.759-22.288.364,6.669,3.552,8.394a5.6,5.6,0,0,0,5.554-.663c.554-.628-1.979-9.495-3.125-12.485s-2.242-9.169-4.834-11.361-6.249-1.82-7.508-2.335-5.484-.146-6.55-.257A38.769,38.769,0,0,0,1456.454,610.086Z",
    transform: "translate(-1434.776 -592.71)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67134",
    "data-name": "Path 67134",
    d: "M1603.934,695.254s-3.728,1.127-4.019,1.515-.808,1.939,0,2.585,1.694,1.13,2.652.384,1.832-1.75,2.386-1.876a20.344,20.344,0,0,0,2.906-.162c.7-.273,2.015-5.546,1.482-5.865S1603.934,695.254,1603.934,695.254Z",
    transform: "translate(-1555.249 -655.585)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67135",
    "data-name": "Path 67135",
    d: "M1504.347,573.575c-1.2-.25-3.526-2.521-3.739-4.829-.208-2.249-1.861-8.568,3.895-10.938,5.4-2.224,10.959.064,11.758,2.807.746,2.561-5.594,2.676-7.918,4.345s-2.482,2.776-3.062,2.512S1504.347,573.575,1504.347,573.575Z",
    transform: "translate(-1482.652 -556.911)",
    fill: "#e64d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67136",
    "data-name": "Path 67136",
    d: "M1514.795,599.3c-.076,1.03-.335,6.012.1,6.745a3.854,3.854,0,0,0,3.86,2.545c2.76-.086,4.551-2.847,4.7-3.17s-.173-4.313-.173-4.982-3.709-2.243-5.2-2.2S1514.866,598.33,1514.795,599.3Z",
    transform: "translate(-1493.197 -587.138)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67137",
    "data-name": "Path 67137",
    d: "M1509.195,580.271c.312-.009-.056,1.89.508,2.51s3.019,3.856,5.616,3.54c2.246-.273,1.924-2.209,2.248-3.8.294-1.447,1.228-1.571,1.555-5.349.127-1.462.818-3.751-.451-4.174s-6.035-1.551-7.219,0-1.3,5.274-1.918,4.794-1.918-2.82-2.679-1.551S1507.531,580.319,1509.195,580.271Z",
    transform: "translate(-1487.344 -568.095)",
    fill: "#f2dad4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67138",
    "data-name": "Path 67138",
    d: "M1569.769,673.1l-7.56,9.558a.751.751,0,0,0,.6,1.217l13.973-.237a.75.75,0,0,0,.588-.3l7.141-9.543a.682.682,0,0,0-.551-1.09l-13.611.113A.75.75,0,0,0,1569.769,673.1Z",
    transform: "translate(-1527.866 -641.609)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67139",
    "data-name": "Path 67139",
    d: "M1619.36,688.506c-.736.074-1.8.488-1.8.872s.858.49,1.094.526.547.11.459.228-.266.71-.739.606a28.953,28.953,0,0,0-2.943-.133c-.4,0-.872.281-.9.577s-.118.355-.355.37-.666.237-.666.621.95.731.95.867a17,17,0,0,0,2.229,1.486c.365.211,1.048.75,1.432.75a1.165,1.165,0,0,0,1.076-.894c.048-.529.807-.913.817-1.173s-.24-.452-.212-.615.692-.394.692-.807a4.686,4.686,0,0,0-.3-1.144c-.038-.173-.192-.548-.038-.6s.692-.548.6-1.009S1619.7,688.471,1619.36,688.506Z",
    transform: "translate(-1565.504 -653.16)",
    fill: "#ffd3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67140",
    "data-name": "Path 67140",
    d: "M1477.491,966.624c.84.454,1.311,1.834,1.43,1.852s.341-.017.341-.154-.034-.6.119-.6.324.751.358,1.842.422,3.695,0,4.026c-.265.208-2.7,1.484-2.763,1.655s.051,1.365-.154,1.552-.682.648-1.058.665a16.309,16.309,0,0,1-3.565,0,7.853,7.853,0,0,1-2.354-.87,12.534,12.534,0,0,1,.58-3.395c.324-.358,2.661-3.565,2.849-3.855a3.309,3.309,0,0,0,.324-1.4,1.8,1.8,0,0,1,1.06-1.518A4.821,4.821,0,0,1,1477.491,966.624Z",
    transform: "translate(-1460.426 -856.355)",
    fill: "url(#linear-gradient-8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTableImg);
export default __webpack_public_path__ + "static/media/empty_table_img.5ba7a5567341ee65e789abaafbefc37a.svg";
export { ForwardRef as ReactComponent };